module.exports = __webpack_public_path__ + "static/ahmed-oulad-hadjou-cv-6ae10ba0c74ed2ab0236d0200bb15eeb.pdf";